import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  left: 0;\n  margin: ", "px ", "px 0;\n  position: absolute;\n  right: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useState } from 'react';
import styled from 'styled-components';
import Autosuggest from 'react-autosuggest';
import { property } from '@scp/ui-shared/theme/variables'; // eslint-disable-next-line import/no-relative-parent-imports

import { TextField } from '../TextField'; // eslint-disable-next-line import/no-relative-parent-imports

import { FIELD_INNER_PADDING, FIELD_DROPDOWN_MARGIN_TOP, FIELD_MARGIN_BOTTOM } from '../constants'; // eslint-disable-next-line import/no-relative-parent-imports

import { Dropdown, Option } from '../dropdown';
var DROPDOWN_MAX_HEIGHT = 200;
var AUTOSUGGEST_STYLES = {
  suggestionsList: {
    margin: 0,
    listStyleType: 'none',
    padding: '0.28em 0'
  },
  suggestionsContainer: {
    opacity: 0,
    maxHeight: 0,
    transition: "opacity ".concat(property.transition, ", max-height ").concat(property.transition)
  },
  suggestionsContainerOpen: {
    opacity: 1,
    maxHeight: "".concat(DROPDOWN_MAX_HEIGHT, "px")
  }
};
var SuggestionsContainerWrapper = styled(Dropdown)(_templateObject(), FIELD_DROPDOWN_MARGIN_TOP - FIELD_MARGIN_BOTTOM, FIELD_INNER_PADDING);
var AutosuggestWrapper = styled.div(_templateObject2());

function renderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children,
      query = _ref.query;
  return React.createElement(SuggestionsContainerWrapper, Object.assign({}, containerProps), children);
}

function renderSuggestion(suggestion, _ref2) {
  var query = _ref2.query,
      isHighlighted = _ref2.isHighlighted;
  return React.createElement(Option, {
    isMulti: false,
    isFocused: isHighlighted,
    isSelected: false
  }, suggestion);
}
/**
 * @example ./__docs__/AutoCompleteField.md
 */


export var AutoCompleteField = function AutoCompleteField(_a) {
  var _a$value = _a.value,
      value = _a$value === void 0 ? '' : _a$value,
      _a$suggestions = _a.suggestions,
      suggestions = _a$suggestions === void 0 ? [] : _a$suggestions,
      onSuggestionsFetch = _a.onSuggestionsFetch,
      onSuggestionsClear = _a.onSuggestionsClear,
      _onChange = _a.onChange,
      onBlur = _a.onBlur,
      textFieldProps = __rest(_a, ["value", "suggestions", "onSuggestionsFetch", "onSuggestionsClear", "onChange", "onBlur"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();

      if (event.target instanceof HTMLInputElement) {
        event.target.blur();
      }
    }
  };

  var renderInputComponent = function renderInputComponent(inputProps) {
    return React.createElement(TextField, Object.assign({}, textFieldProps, inputProps, {
      onKeyPress: handleKeyPress
    }));
  };

  return React.createElement(AutosuggestWrapper, null, React.createElement(Autosuggest, {
    theme: AUTOSUGGEST_STYLES,
    suggestions: suggestions,
    onSuggestionsFetchRequested: function onSuggestionsFetchRequested(_ref3) {
      var value = _ref3.value;
      return onSuggestionsFetch(value);
    },
    onSuggestionsClearRequested: onSuggestionsClear,
    getSuggestionValue: function getSuggestionValue(suggestion) {
      return suggestion;
    },
    renderSuggestion: renderSuggestion,
    renderInputComponent: renderInputComponent,
    renderSuggestionsContainer: renderSuggestionsContainer,
    focusInputOnSuggestionClick: false,
    highlightFirstSuggestion: true,
    inputProps: {
      value: localValue,
      onChange: function onChange(event, _ref4) {
        var newValue = _ref4.newValue,
            method = _ref4.method;
        setLocalValue(newValue);

        if (_onChange) {
          _onChange(newValue);
        }
      }
    }
  }));
};